module.exports = __webpack_public_path__ + "img/7@2x.87eb9faf.png";